var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#D66C6C","fillRule":"evenodd"},[React.createElement("path",{"d":"M8.504 9.443 15.8 16.74l1.214-1.214L8.489 7 7.275 8.214l.01.011L0 15.511l1.218 1.218 7.286-7.286Z","key":0}),React.createElement("path",{"d":"M8.511 7.297 1.214 0 0 1.214 8.526 9.74 9.74 8.526l-.01-.011 7.285-7.286L15.797.011 8.51 7.297Z","key":1})]));
}

Cross.defaultProps = {"width":"17","height":"17"};

module.exports = Cross;

Cross.default = Cross;
